var MndStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService, SearchContainerHeight } from "./afla-module-strategy.service";
import _ from "underscore";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { SearchAssignedToComponent } from "../../../tabs/applications/application-search/search-assigned-to/search-assigned-to.component";
import { ApplicationSearchService } from "../../../tabs/applications/shared/application-search.service";
import { catchError, distinctUntilChanged, map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject, throwError } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "../../models/alert";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { ApplicationSearchConstants } from "../../../tabs/applications/application-search/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { SearchCreatedDateComponent } from "../../../tabs/applications/application-search/search-created-date/search-created-date.component";
import { Router } from "@angular/router";
import { SearchStatusComponent } from "../../../tabs/applications/application-search/search-status/search-status.component";
import { SearchOptionsConstants } from "../../../core/settings/components/search-options/search-options-constants";
import { ApiSearchOptionConstants } from "../../constants/api-constants/api-search-option.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import { SearchStartDateComponent } from "../../../tabs/applications/application-search/search-start-date/search-start-date.component";
import { SearchCategoryComponent } from "../../../tabs/applications/application-search/search-category/search-category.component";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { ApiMondiConstants } from "../../constants/api-constants/api-mondi.constants";
import { ViewApplicationDetailsMndComponent } from "../../../application/view-application/modules/mnd/view-application-details-mnd/view-application-details-mnd.component";
import { ViewApplicationLocationMndComponent } from "../../../application/view-application/modules/mnd/view-application-location-mnd/view-application-location-mnd.component";
import { CreateApplicationDetailsMndComponent } from "../../../application/create-application/modules/mnd/create-application-details-mnd/create-application-details-mnd.component";
import { CreateApplicationLocationMndComponent } from "../../../application/create-application/modules/mnd/create-application-location-mnd/create-application-location-mnd.component";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { ModulePrefix } from "../../models/module-prefix.model";
// TODO these columns will be added back when we do advanced searches
// Not to be sorted!!!! ==> Already in correct sort order
// Please do not rename the enums ==> it will break the SearchOptions Field?Column Settings! Labels can be changed without any impact.
export var MndSearchOptions;
(function (MndSearchOptions) {
    MndSearchOptions["ReferenceNumber"] = "Reference Number";
    MndSearchOptions["MyApplications"] = "My Applications";
    MndSearchOptions["ApplicationsCreatedByMe"] = "Applications Created By Me";
    MndSearchOptions["AppID"] = "Application ID";
    MndSearchOptions["ApplicationStatus"] = "Application Status";
    MndSearchOptions["ApplicationCategory"] = "Application Category";
    MndSearchOptions["ApplicationsWithoutStartDate"] = "Applications Without Start Date";
    MndSearchOptions["AssignedToUsers"] = "Assigned to";
    MndSearchOptions["UnassignedApplications"] = "Unassigned Applications";
    MndSearchOptions["CreatedDate"] = "Created Date";
    MndSearchOptions["CreatedDateRange"] = "Created Date Range";
    MndSearchOptions["StartDate"] = "Started Date";
    MndSearchOptions["StartDateRange"] = "Started Date Range";
    MndSearchOptions["DaysUntilExpired"] = "Days until Expired";
    MndSearchOptions["PercentageComplete"] = "Percentage Complete";
    MndSearchOptions["TimeoutStatus"] = "Timeout Status";
    MndSearchOptions["JobID"] = "Job ID";
})(MndSearchOptions || (MndSearchOptions = {}));
// TODO these columns will change depending on how columns have been configured. This is the default list
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Description"] = "Description";
    ApplicationHeadingEnum["Details"] = "Details";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["CreatedBy"] = "Created By";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Description, "description"],
    [ApplicationHeadingEnum.Details, "details"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.CreatedBy, "createdBy"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["StartDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Phase";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
    ApplicationSummaryColumnsEnum["CreatedBy"] = "Created By";
    ApplicationSummaryColumnsEnum["Details"] = "Details";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Details, "details"],
    [ApplicationSummaryColumnsEnum.StartDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.CreatedBy, "createdBy"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const MndSearchQueryLookup = new Map([
    [MndSearchOptions.AppID, "appId"],
    [MndSearchOptions.ReferenceNumber, "referenceNumber"],
    [MndSearchOptions.JobID, "jobId"]
]);
export const MndAdditionalSearchOptions = [MndSearchOptions.MyApplications,
    MndSearchOptions.ApplicationsCreatedByMe,
    MndSearchOptions.AssignedToUsers,
    MndSearchOptions.UnassignedApplications,
    MndSearchOptions.ApplicationsWithoutStartDate];
export const MndDateSearchOptions = new Map([
    [MndSearchOptions.CreatedDate, 1],
    [MndSearchOptions.CreatedDateRange, 2],
]);
export const MndStartRangeDateSearchOptions = new Map([
    [MndSearchOptions.StartDate, 1],
    [MndSearchOptions.StartDateRange, 2],
]);
export const MndStatusSearchOptions = new Map([
    [MndSearchOptions.ApplicationStatus, ApplicationSearchConstants.STATUS],
    [MndSearchOptions.PercentageComplete, ApplicationSearchConstants.PERCENT_COMPLETE],
    [MndSearchOptions.DaysUntilExpired, ApplicationSearchConstants.DAYS_UNTIL_EXPIRED],
    [MndSearchOptions.TimeoutStatus, ApplicationSearchConstants.TIMEOUT_STATUS],
]);
export const MndSearchOptionClientHeight = new Map([
    [MndSearchOptions.ReferenceNumber, SearchContainerHeight.Simple],
    [MndSearchOptions.MyApplications, SearchContainerHeight.Simple],
    [MndSearchOptions.ApplicationsCreatedByMe, SearchContainerHeight.Simple],
    [MndSearchOptions.AppID, SearchContainerHeight.Simple],
    [MndSearchOptions.ApplicationStatus, SearchContainerHeight.SingleLine],
    [MndSearchOptions.PercentageComplete, SearchContainerHeight.SingleLine],
    [MndSearchOptions.DaysUntilExpired, SearchContainerHeight.SingleLine],
    [MndSearchOptions.TimeoutStatus, SearchContainerHeight.SingleLine],
    [MndSearchOptions.CreatedDate, SearchContainerHeight.SingleLine],
    [MndSearchOptions.AssignedToUsers, SearchContainerHeight.SingleLine],
    [MndSearchOptions.CreatedDateRange, SearchContainerHeight.SingleLine]
]);
// TODO: Other tables?
// IMPORTANT: these values much match the DB table names and the Property names used by oData entity for TownPlanning
export var MndSearchOptionTableListEnum;
(function (MndSearchOptionTableListEnum) {
    MndSearchOptionTableListEnum["Application"] = "MND_APPLICATION|Application";
    MndSearchOptionTableListEnum["Status"] = "AFLA_APPLICATIONSTATUS|Status";
})(MndSearchOptionTableListEnum || (MndSearchOptionTableListEnum = {}));
export const MndExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_MND;
export const MndTableNameListForSearchOptions = MndSearchOptionTableListEnum.Application
    + "," + MndSearchOptionTableListEnum.Status;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Details"] = "Details";
    CreateApplicationMenuHeadings["Location"] = "Location";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Details"] = "Details";
    ViewApplicationMenuHeadings["Location"] = "Location";
    ViewApplicationMenuHeadings["Assessment"] = "Assessment";
    ViewApplicationMenuHeadings["Attachments"] = "Attachments";
    // Checklist = "Checklist",
    ViewApplicationMenuHeadings["RelatedApplicationSearch"] = "Related applications";
    ViewApplicationMenuHeadings["RequiredDocumentsChecklist"] = "Required documents checklist";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Conditions"] = "Conditions";
    ViewApplicationMenuHeadings["History"] = "History";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    // Result = "Result",
    ViewApplicationMenuHeadings["ScheduledReminders"] = "Scheduled Reminders";
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["StepManagement"] = "Step management";
    ViewApplicationMenuHeadings["Survey123"] = "Survey123";
    ViewApplicationMenuHeadings["Timeouts"] = "Timeouts";
    ViewApplicationMenuHeadings["Team"] = "Team";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export var SettingsMenuHeadings;
(function (SettingsMenuHeadings) {
    SettingsMenuHeadings["AvailableSurvey123s"] = "Available survey123s";
    SettingsMenuHeadings["Lookups"] = "Lookups";
    SettingsMenuHeadings["MapConfig"] = "Map services";
    SettingsMenuHeadings["NonWorkingDays"] = "Non-working days";
    SettingsMenuHeadings["AttachmentTypes"] = "Attachment types";
    SettingsMenuHeadings["Recipients"] = "Recipients";
    SettingsMenuHeadings["RecipientGroups"] = "Recipient groups";
    SettingsMenuHeadings["Reports"] = "Reports";
    SettingsMenuHeadings["StepMetaData"] = "Step metadata";
    SettingsMenuHeadings["Tariffs"] = "Tariffs";
    SettingsMenuHeadings["Templates"] = "Templates";
    SettingsMenuHeadings["NotificationTemplates"] = "Notification templates";
    SettingsMenuHeadings["ModuleRoles"] = "Module roles";
    // AFLAPortalDocuments = "Afla portal documents",
    // AFLAPortalUpdateOwners = "Afla portal update owners",
    SettingsMenuHeadings["SearchOptions"] = "Search options";
    SettingsMenuHeadings["SearchSettings"] = "Search settings";
    SettingsMenuHeadings["BackupRestore"] = "Backup and restore";
    SettingsMenuHeadings["ArcGISItems"] = "ArcGIS items";
    SettingsMenuHeadings["AFLAPortalMessagesAndPages"] = "AFLA portal messages and pages";
    SettingsMenuHeadings["InvoiceTemplates"] = "Invoice templates";
    SettingsMenuHeadings["Stamps"] = "Stamps";
    SettingsMenuHeadings["ApplicationWorkflowUpgrade"] = "Application workflow upgrade";
})(SettingsMenuHeadings || (SettingsMenuHeadings = {}));
export const MndRequiredMapFields = [];
let MndStrategyService = class MndStrategyService extends AflaModuleStrategyService {
    static { MndStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    http;
    appController;
    router;
    buildingUseSearchOptions;
    overdueApplicationExpandFields = "status";
    showApplicantAgentForModule = true;
    requiredMapFields;
    createApplicationMenuHeadings;
    overrideMapDefault = {};
    dynamicTitle = {
        Applications: "Applications",
        Application: "Application",
        CreateApplicationLinkText: "Create Application",
        CreateApplicationTitle: "Create Application",
        ViewApplicationTitle: "View Application",
    };
    viewApplicationComponentLookup;
    name = ModuleConfig.Mondi;
    modulePrefix = ModulePrefix.Mondi;
    searchQueryLookup;
    defaultSearchColumns;
    searchOptions;
    applicationEndpoint;
    extendedSimpleSearchOptions;
    dateSearchOptions;
    RangeSearchOptions;
    statusSearchOptions;
    groupSearchOptions;
    clientHeightMap;
    createApplicationComponentLookup;
    advancedSearchComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    // column headers are dynamic
    applicationTableColumnMap = new BehaviorSubject(null);
    applicationTableColumnMapObservable;
    applicationServiceUrl = ApiMondiConstants.URL;
    form;
    lookups = new Map();
    userId;
    moduleUsers;
    expandListForApplicationSearch = MndExpandListForApplicationSearch;
    expandListForApplicationSearchFullList = MndExpandListForApplicationSearch;
    searchOptionTableNameList = MndTableNameListForSearchOptions;
    customApplicationTableColumnMap;
    selectedSearchOptionLookup;
    searchOptionsWithCustomColumns = [];
    searchOptionsFieldList;
    searchOptionsMap;
    isPrevSavedSearch = false;
    aflaPortalConfigurableMessages = [
        "Welcome help",
        "Welcome page",
        "Property help",
        "Application help",
        "Agent help",
        "Professional bodies help",
        "Required documentation help",
        "Notes help",
        "Communication help",
        "Applicant help",
        "Summary help",
        "Create application status page",
        "View application status page"
    ];
    setApplicantAndApplicantAgentAction = "";
    settingsMenuHeadings;
    settingsComponentLookup;
    propertiesPageHeading = "Properties";
    moduleRequiredMaps;
    stampOptions = [];
    previousApplication = null;
    statusColumn = "status/ workflowSection";
    createApplicationMndSubscription;
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, requestStatusService, http, appController, router) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.initForm();
        this.applicationEndpoint = ApiApplicationSearchConstants.MONDI_ENDPOINT;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        this.settingsMenuHeadings = SettingsMenuHeadings;
        this.moduleRequiredMaps = ["Property"];
        this.requiredMapFields = MndRequiredMapFields;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    // the format for a column filter on an child table is:
    //    EQUALS ==> applicantAgent/any(m:m/name eq 'xxxx')
    //    CONTAINS with tolower ==> applicantAgent/any(b:contains(tolower(b/name),'xxxx'))
    static buildColumnFilter(text, filter) {
        const column = filter ? filter : ApplicationSearchConstants.DEFAULT_SEARCH;
        return `contains(tolower(cast(${column.trim()},'Edm.String')),'${text.trim().toLowerCase()}') and eLodgementComplete eq true`;
    }
    static buildExpand(params, top) {
        params = params.set(ODataAction.Expand, MndExpandListForApplicationSearch);
        params = params.set(ODataAction.Top, top);
        params = params.set(ODataAction.OrderBy, "startDate desc, appId desc");
        return params;
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    buildListFilter(list, column) {
        const params = MndStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getStatusForModule(moduleID, statusField) {
        return this.applicationSearchService.getStatusForModule(moduleID, statusField);
    }
    getUsersForModule(moduleID) {
        return this.applicationSearchService.getUsersForModule(moduleID);
    }
    initializeSearchQueryLookup() {
        this.searchQueryLookup = MndSearchQueryLookup;
    }
    initializeAdditionalSearchLookup() {
        this.extendedSimpleSearchOptions = MndAdditionalSearchOptions;
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initializeSearchOptionsLookup() {
        this.searchOptions = new Array();
        this.searchOptions.push(..._.values(MndSearchOptions));
        // this is used for the SearchOptions settings
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(MndSearchOptions)) {
            this.searchOptionsMap.set(key, value);
        }
        // default column list if search option types does not have a default
        this.defaultSearchColumns = applicationHeadingLookup;
    }
    initializeDateSearchOptions() {
        this.dateSearchOptions = MndDateSearchOptions;
        this.RangeSearchOptions = MndStartRangeDateSearchOptions;
    }
    initializeStatusSearchOptions() {
        this.statusSearchOptions = MndStatusSearchOptions;
        this.clientHeightMap = MndSearchOptionClientHeight;
    }
    initializeGroupSearchOptions = () => {
    };
    getFieldListForSearchOptions(moduleId) {
        const params = {
            $filter: MndStrategyService_1.buildModuleIDFilter(moduleId),
            $expand: SearchOptionsConstants.SEARCH_OPTIONS_EXPAND,
            $orderby: SearchOptionsConstants.SEARCH_OPTIONS_COLUMNS_ORDERBY
        };
        const url = `${ApiSearchOptionConstants.URL}`;
        return this.http.get(url, { params }).pipe(map((response) => {
            this.searchOptionsWithCustomColumns = [];
            this.searchOptionsFieldList = response.value;
            this.searchOptionsFieldList.forEach((option) => {
                const searchOptionLookup = this.getSearchOptionLookup(option.searchOption);
                // @ts-ignore
                if (this.searchOptionsWithCustomColumns.indexOf(searchOptionLookup) < 0) { // @ts-ignore
                    this.searchOptionsWithCustomColumns.push(searchOptionLookup);
                }
            });
            return response.value;
        }));
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            startDate: application.createdDate !== null
                ? this.saShortDatePipe.transform(application.startDate)
                : "",
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null
                ? this.saShortDatePipe.transform(application.lastEditedDate)
                : "",
            moduleId: application.moduleId,
            description: application.description,
            createdBy: application.createdUser,
            // todo - Lawrence - this is here the details are being built up
            // details: application.layerName !== null ? `${application.layerName} ${application.featureName}` : "",
            details: application.locationDetail !== null ? application.locationDetail : application.layerName !== null ? `${application.layerName} ${application.featureName}` : "",
            lid: application.lid !== null ? application.lid : "",
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getApplicationFieldValue(application, appGroup, fieldName) {
        let fieldValue;
        for (const [key, value] of Object.entries(application)) {
            if (!fieldValue && appGroup.toLowerCase() === "application") {
                if (key.toLowerCase() === fieldName.toLowerCase()) {
                    fieldValue = value;
                    break;
                }
            }
            else {
                if (!fieldValue
                    && key.toLowerCase() === appGroup.toLowerCase()) {
                    // some applications may have null lower order properties e.g. Status
                    if (value) {
                        const group = value[0] ? value[0] : value;
                        for (const [groupKey, groupValue] of Object.entries(group)) {
                            switch (appGroup.toLowerCase()) {
                                case "status":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        switch (fieldName.toLowerCase()) {
                                            case "assignedto":
                                            case "createdby":
                                                // these fields will be handled in the user section below
                                                break;
                                            default:
                                                fieldValue = groupValue;
                                                break;
                                        }
                                        break;
                                    }
                                    break;
                                // the following properties can be multiple values - we cannot use ObjectUtils.getCommaSeparatedValuesFromListForKey because it is case sensitive
                                // case "properties":
                                //   if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                //     fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                //   }
                                //   break;
                            }
                        }
                    }
                }
                if (fieldValue)
                    break;
            }
        }
        // 3rd level tables
        // const propertyDetails = ["owners", "applicationzonings", "propertybuildings"];
        // if (!fieldValue && propertyDetails.indexOf(appGroup.toLowerCase()) > -1) {
        //   if (application.properties.length > 0) {
        //     application.properties.forEach((property) => {
        //       for (const [propkey, propVal] of Object.entries(property)) {
        //         if (propkey.toLowerCase() === appGroup.toLowerCase()
        //           || (propkey.toLowerCase().endsWith( "zonings") && appGroup.toLowerCase().endsWith("zonings"))
        //           || (propkey.toLowerCase().endsWith( "buildings") && appGroup.toLowerCase().endsWith("buildings"))) {
        //           propVal.forEach((value) => {
        //             for (const [groupKey, groupValue] of Object.entries(value)) {
        //               if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
        //                 fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
        //               }
        //             }
        //           })
        //         }
        //       }
        //     })
        //   }
        // }
        if (!fieldValue)
            fieldValue = "";
        if (fieldName.toLowerCase().endsWith("date") || fieldName.toLowerCase().startsWith("date")) {
            fieldValue = fieldValue ? this.saShortDatePipe.transform(fieldValue) : "";
        }
        else {
            switch (fieldName.toLowerCase()) {
                case "lasteditedby":
                    fieldValue = this.getUserName(application.lastEditedUser);
                    break;
                case "createdby":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.createdBy) : "";
                    break;
                case "assignedto":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.assignedTo) : "";
                    break;
                case "createduserid":
                    fieldValue = this.getUserName(application.createdSystemUser);
                    break;
            }
        }
        return fieldValue;
    }
    customColumnSearchModel(application, columnList, isPrevSavedSearch = false) {
        // need to reset the column map if the search options customised columns have been updated
        if ((this.customApplicationTableColumnMap.size !== 0 && columnList.length !== this.customApplicationTableColumnMap.size)
            || isPrevSavedSearch) {
            this.customApplicationTableColumnMap.clear();
            this.isPrevSavedSearch = false;
        }
        let resetHeadings = this.customApplicationTableColumnMap.size === 0;
        const appDetails = {};
        if (columnList.length > 0) {
            columnList.forEach((column) => {
                const fieldAlias = column.moduleField.fieldAlias;
                const fieldName = column.moduleField.fieldName;
                const tableLookup = this.getSearchOptionLookup(`${column.moduleField.tableAlias}`);
                const appGroup = this.getApplicationTableProperty(`${column.moduleField.tableName}|${tableLookup}`);
                const appProperty = `${appGroup.toLowerCase()}${fieldName.toLowerCase()}`;
                appDetails[appProperty] = this.getApplicationFieldValue(application, tableLookup, fieldName);
                if (resetHeadings)
                    this.customApplicationTableColumnMap.set(fieldAlias, appProperty);
            });
            // standard fields to add in case the user did not add them
            // @ts-ignore
            appDetails.id = application.id;
            // @ts-ignore
            appDetails.moduleId = application.moduleId;
            // @ts-ignore
            appDetails.jobId = application.jobId;
            // @ts-ignore
            appDetails.appId = application.appId;
            // only set the headings once for the search
            if (resetHeadings) {
                this.changeAppTableColumnMap(this.customApplicationTableColumnMap);
                resetHeadings = false;
            }
            return appDetails;
        }
        else
            return this.defaultSearchModel(application);
    }
    getApplicationTableProperty(tableName) {
        let property = "";
        for (const [tableKey, tableValue] of Object.entries(MndSearchOptionTableListEnum)) {
            if (tableValue.toLowerCase() === tableName.toLowerCase()) {
                // @ts-ignore
                property = tableKey;
                break;
            }
        }
        return property;
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getCustomApplicationSearchModel(searchOptionLookup) {
        // identify columnList for specific search option
        return this.applicationSearchService.getSearchOptionColumnList(this, searchOptionLookup);
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        if (application) {
            return this.defaultSearchModel(application);
        }
    }
    initializeSettingsComponents() {
        this.settingsComponentLookup = new Map([]);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [
                ViewApplicationMenuHeadings.Details,
                ViewApplicationDetailsMndComponent,
            ],
            [
                ViewApplicationMenuHeadings.Location,
                ViewApplicationLocationMndComponent,
            ]
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [
                CreateApplicationMenuHeadings.Details,
                CreateApplicationDetailsMndComponent,
            ],
            [
                CreateApplicationMenuHeadings.Location,
                CreateApplicationLocationMndComponent,
            ],
        ]);
    }
    initializeAdvancedApplicationSearchComponents() {
        this.advancedSearchComponentLookup = new Map([
            [MndSearchOptions.AssignedToUsers, SearchAssignedToComponent],
            [MndSearchOptions.CreatedDate, SearchCreatedDateComponent],
            [MndSearchOptions.CreatedDateRange, SearchCreatedDateComponent],
            [MndSearchOptions.StartDate, SearchStartDateComponent],
            [MndSearchOptions.StartDateRange, SearchStartDateComponent],
            [MndSearchOptions.PercentageComplete, SearchStatusComponent],
            [MndSearchOptions.ApplicationStatus, SearchStatusComponent],
            [MndSearchOptions.ApplicationCategory, SearchCategoryComponent],
            [MndSearchOptions.TimeoutStatus, SearchStatusComponent],
            [MndSearchOptions.DaysUntilExpired, SearchStatusComponent],
        ]);
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    initializeApplicationTableColumnMap() {
        this.applicationTableColumnMapObservable = this.applicationTableColumnMap.asObservable();
        this.changeAppTableColumnMap(this.customApplicationTableColumnMap
            ? this.customApplicationTableColumnMap : applicationHeadingLookup);
    }
    changeAppTableColumnMap(tableColumnMap) {
        this.applicationTableColumnMap.next(tableColumnMap);
    }
    doSearchApplicationsByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsByResponsiblePerson(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsByCreatedByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsCreatedByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchUnassignedApplications(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUnassignedApplication(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsWithoutStartDate(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsWithoutStartDate(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "appId", true, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doApplicationSearch(search, moduleID, pageHeading, withDefaultColumns) {
        const column = this.getEntityColumn(search.column);
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsUsingSimpleSearch(search.text, column, this, moduleID, withDefaultColumns)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationsQuery(params) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    getApplicationsQueryExtended(params, extendedEndPoint) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint, extendedEndPoint), { params });
    }
    getApplicationsSearchRequestWithAdditionalFilters(text, filter, moduleID) {
        let params = MndStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, AflaModuleStrategyService.buildModuleIDFilter(moduleID), MndStrategyService_1.buildColumnFilter(text, filter));
        return this.getApplicationsQuery(params);
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = MndStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, MndStrategyService_1.buildModuleIDFilter(moduleID), MndStrategyService_1.showCompleteApplications());
        return this.getApplicationsQuery(params);
    }
    static showCompleteApplications() {
        return `status/workflowSection ne 'Completed'`;
    }
    buildDashboardApplicationsSearch(moduleID, dashboardFilter) {
        let params = MndStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.applicationSearchService.dashboardSearch(params, dashboardFilter, moduleID);
        return this.getApplicationsQuery(params);
    }
    createApplication() {
        this.requestStatusService.showBusySpinner("CreateMndApplication");
        const application = this.buildApplication();
        this.createApplicationMndSubscription =
            this.postApplicationService(application)
                .subscribe({
                next: (savedApplication) => {
                    this.appController.showMessage(MndStrategyService_1.successMessage(savedApplication.jobId), AlertType.Success);
                    this.resetForm();
                    this.requestStatusService.removeBusySpinner("CreateMndApplication");
                    this.router.navigate([
                        AppRoutingConstants.ROUTE_SEPERATOR + ApplicationsRoutingConstants.REFRESH_ROUTE,
                        {
                            jobId: savedApplication.jobId,
                            moduleId: this.appController.selectedModuleID,
                            type: ApplicationsRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE
                        }
                    ]);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("CreateMndApplication");
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
                }
            });
    }
    saveDraftApplication() {
    }
    getDraftApplication() {
        return null;
    }
    getApplicationGeometries(jobID, moduleID) {
        const params = {
            $select: "applicationPoint, applicationLine,applicationPolygon",
            $expand: "applicationPoint, applicationLine, applicationPolygon",
            $filter: `jobId eq ${+jobID} and moduleId eq ${+moduleID}`
        };
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    resetForm() {
        this.form.reset();
    }
    postApplicationService(params) {
        return this.http.post(ApiMondiConstants.URL, params);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, lastEditedUser";
    }
    initForm() {
        // this.tableHeadingsIsChangedObservable = this.tableHeadingsIsChanged.asObservable()
        this.form = new FormGroup({
            noteForm: new FormGroup({
                newNote: new FormControl(null),
                notes: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null),
                applicationType: new FormControl(null, [Validators.required]),
                referenceNumber: new FormControl(null),
            }),
            locationForm: new FormGroup({
                region: new FormControl(null),
                area: new FormControl(null),
                wpu: new FormControl(null),
                plantation: new FormControl(null),
                compartment: new FormControl(null),
                trial: new FormControl(null),
                selectedGraphic: new FormControl(null),
                selectedLayer: new FormControl(null, [Validators.required]),
                selectedFeatureName: new FormControl(null, [Validators.required]),
                selectedFeatureKey: new FormControl(null, [Validators.required]),
                locationDetail: new FormControl(null),
                lid: new FormControl(null),
                point: new FormControl(null),
                polyline: new FormControl(null),
                polygon: new FormControl(null),
                polylineDto: new FormControl(null),
                polygonDto: new FormControl(null),
                pointDto: new FormControl(null),
            }),
        });
    }
    getEntityColumn(searchColumn) {
        switch (searchColumn) {
            case SharedConstants.SEARCH_BY_DEFAULT:
                return SharedConstants.SEARCH_BY_DEFAULT;
            case SharedConstants.DASHBOARD_FILTERS.LatestApplications:
                return SharedConstants.DASHBOARD_FILTERS.LatestApplications;
            case SharedConstants.DASHBOARD_FILTERS.OverdueApplications:
                return SharedConstants.DASHBOARD_FILTERS.OverdueApplications;
            case SharedConstants.DASHBOARD_FILTERS.OpenApplications:
                return SharedConstants.DASHBOARD_FILTERS.OpenApplications;
            case SharedConstants.DASHBOARD_FILTERS.ClosedApplications:
                return SharedConstants.DASHBOARD_FILTERS.ClosedApplications;
            case SharedConstants.DASHBOARD_FILTERS.TotalApplications:
                return SharedConstants.DASHBOARD_FILTERS.TotalApplications;
            case SharedConstants.DASHBOARD_FILTERS.ApplicationStatus:
                return this.statusColumn;
            default:
                return this.searchQueryLookup.get(searchColumn);
        }
    }
    buildApplication() {
        const point = this.form.get("locationForm").get("point").value;
        const polyline = this.form.get("locationForm").get("polyline").value;
        const polygon = this.form.get("locationForm").get("polygon").value;
        const regionLabel = this.form.get("locationForm").get("region").value;
        const areaLabel = this.form.get("locationForm").get("area").value;
        const wpuLabel = this.form.get("locationForm").get("wpu").value;
        const plantationLabel = this.form.get("locationForm").get("plantation").value;
        const compartmentLabel = this.form.get("locationForm").get("compartment").value;
        // shape: WktConverterUtils.ConvertArcGISJsonToWkt(centroid),
        //   wkid: 102100,
        const application = {
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            applicationType: this.form.get("detailsForm").get("applicationType").value.value,
            layerName: this.form.get("locationForm").get("selectedLayer").value,
            featureName: this.form.get("locationForm").get("selectedFeatureName").value,
            featureKey: this.form.get("locationForm").get("selectedFeatureKey").value,
            description: this.form.get("detailsForm").get("description").value,
            locationDetail: this.form.get("locationForm").get("locationDetail").value,
            lid: this.form.get("locationForm").get("lid").value,
            trial: this.form.get("locationForm").get("trial").value,
            notes: [],
            applicationPoint: null,
            applicationLine: null,
            applicationPolygon: null
        };
        if (polygon !== null) {
            const applicationPolygon = {
                wkid: 102100,
                shape: WktConverterUtils.ConvertArcGISJsonToWkt(polygon)
            };
            application.applicationPolygon = applicationPolygon;
        }
        if (point !== null) {
            const applicationPoint = {
                wkid: 102100,
                shape: WktConverterUtils.ConvertArcGISJsonToWkt(point)
            };
            application.applicationPoint = applicationPoint;
        }
        if (polyline !== null) {
            const applicationLine = {
                wkid: 102100,
                shape: WktConverterUtils.ConvertArcGISJsonToWkt(polyline)
            };
            application.applicationLine = applicationLine;
        }
        const notesArray = this.form.get("noteForm").get("notes");
        notesArray.controls.forEach((item) => {
            const note = {
                note: item.get("note").value,
            };
            application.notes.push(note);
        });
        return application;
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_MND_APPLICATIONS_BY_USER;
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_CREATED_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_MND_APPLICATIONS_CREATED_BY_USER;
        }
    }
    getSearchResponsiblePersonUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON:
                return ApiApplicationSearchConstants.FUNCTION_GET_MND_APPLICATIONS_BY_RESPONSIBLEPERSON;
        }
    }
    generateInvoiceReportService(applicationId, invoiceID, canDownloadInPortal = false) {
        const params = {
            invoiceId: invoiceID,
            canDownloadInPortal
        };
        return this.http.get(`${ApiMondiConstants.URL}/${applicationId}/${ApiMondiConstants.FUNCTION_GET_GENERATE_INVOICE}`, { responseType: "blob", params });
    }
    getRequiredDocumentsChecklist(applicationId, jobId) {
        const params = {
            $filter: jobId
        };
        return this.http.get(`${ApiMondiConstants.URL}/${applicationId}/${ApiMondiConstants.FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getExternalLinks(moduleId, jobId, category) {
        const params = {
            jobId,
            category
        };
        return this.http.get(`${ApiMondiConstants.URL}/${moduleId}/${ApiMondiConstants.FUNCTION_GET_EXTERNAL_LINKS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    initializeBuildingUseSearchOptions() {
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiMondiConstants.URL}/${jobId}/${ApiMondiConstants.FUNCTION_APPLICATION_TYPES}`;
        return this.http.get(url, { params });
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router }
    ];
};
MndStrategyService = MndStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsub()
], MndStrategyService);
export { MndStrategyService };
